export default "__VITE_ASSET__C$9Yr$Dq__"